
<template>
<div style="padding: 20px;width: 100%;overflow: auto">
  <el-card shadow="hover">
    <el-form ref="queryFormRef" :model="queryParams" :inline="true">
      <el-form-item label="渠道订单号" prop="channelOrderNo">
        <el-input v-model="queryParams.channelOrderNo" placeholder="请输入渠道订单号" clearable @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item label="商户订单号" prop="mchOrderNo">
        <el-input v-model="queryParams.mchOrderNo" placeholder="请输入商户订单号" clearable @keyup.enter="handleQuery" />
      </el-form-item>
      <el-form-item label="交易状态" prop="state">
        <el-select v-model="queryParams.state" placeholder="请选择">
          <el-option
              label="未支付"
              value="0">
          </el-option>
          <el-option
              label="支付成功"
              value="2">
          </el-option>
          <el-option
              label="已退款"
              value="5">
          </el-option>
          <el-option
              label="退款中"
              value="7">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" >
        <el-date-picker
            v-model="queryParams.params.createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery">搜索</el-button>
        <el-button icon="Refresh" @click="resetQuery">重置</el-button>
        <el-button v-if="multipleSelection.length>0" icon="Refresh" type="danger" @click="del">删除</el-button>
      </el-form-item>
    </el-form>
  </el-card>

  <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @expand-change="expandChange"
      :lazy="true"
      :row-class-name="tableRowClassName">
    <el-table-column
        type="selection"
        width="55">
    </el-table-column>
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-descriptions title="详细信息">
          <el-descriptions-item label="封面">
            <img v-if="props.row.klCreationVo" style="max-width: 60px" :src="props.row.klCreationVo.cover">
            <img v-if="props.row.klFakaProductVo" style="max-width: 60px" :src="props.row.klFakaProductVo.images?.split(',')[0]">
            <img v-if="props.row.busType=='circle'" style="max-width: 60px" :src="props.row.klCircleVo.avatar">
            <img v-if="props.row.busType=='knowledgeBase'" style="max-width: 60px" :src="props.row.kbKnowledgeBaseVo.coverImage">
          </el-descriptions-item>
          <el-descriptions-item v-if="props.row.user" label="下单用户">{{props.row.user.userName}}</el-descriptions-item>
          <el-descriptions-item v-if="props.row.user" label="头像">
            <el-avatar :src="props.row.user.headImageThumb"></el-avatar>
          </el-descriptions-item>
          <el-descriptions-item label="联系" v-if="props.row.createBy">
            <el-tag size="small"><i style="font-size: 1rem" class="el-icon-chat-dot-round" @click="showUser=true"></i></el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </el-table-column>
    <el-table-column
        label="名称"
        >
      <template slot-scope="props">
        <span v-if="props.row.klCreationVo">{{props.row.klCreationVo.title}} </span>
        <span v-if="props.row.klFakaProductVo">{{props.row.klFakaProductVo.name}} </span>
        <span v-if="props.row.busType=='circle'">{{props.row.klCircleVo.name}} </span>
        <span v-if="props.row.busType=='knowledgeBase'">{{props.row.kbKnowledgeBaseVo.name}} </span>
      </template>
    </el-table-column>
    <el-table-column
        prop="busType"
        label="类型"
    >
    </el-table-column>
    <el-table-column
        prop="mchOrderNo"
        label="商户订单号"
        >
    </el-table-column>
    <el-table-column
        prop="channelOrderNo"
        label="渠道订单号">
    </el-table-column>
    <el-table-column
        prop="amt"
        label="金额">
    </el-table-column>
    <el-table-column
        prop="createTime"
        label="创建时间">
    </el-table-column>
    <el-table-column
        prop="state"
        label="状态">
      <template #default="scope">
        <el-tag type="success"  effect="dark" v-if="scope.row.state==2">支付成功</el-tag>
        <el-tag type="info"  effect="dark" v-if="scope.row.state==0">未支付</el-tag>
        <el-tag type="warning"  effect="dark" v-if="scope.row.state==7">退款中</el-tag>
        <el-tag type="error"  effect="dark" v-if="scope.row.state==5">已退款</el-tag>
      </template>
    </el-table-column>
    <el-table-column
        label="操作"
        >
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" v-if="scope.row.state==2||scope.row.state==7" type="danger" >退款</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      background
      layout="prev, pager, next,total"
      :page-size="12"
      :current-page="queryParams.pageNum"
      @current-change="currentChange"
      :total="total">
  </el-pagination>
  <UserInfo @close="showUser=false" :user="userInfo" v-if="showUser" :pos="pos"></UserInfo>
</div>

</template>
<script>
import UserInfo from "@/components/common/UserInfo.vue";

export default {
  components: {UserInfo},
  methods: {
    handleClick(row){
      this.$http2({
        url: `/klgeek/order/tradeRefund`,
        method: 'put',
        data:{id:row.id}
      }).then((res) => {
        this.$message({
          message: '退款成功',
          type: 'success'
        });
        this.getlist()
      })

    },
    del(){
      let id=[];
      this.multipleSelection.forEach((e)=>{
        id.push(e.id)
      })
     let ids= id.join(",")
      console.log(ids)
      this.$http2({
        url: `/klgeek/order/${ids}`,
        method: 'delete',
      }).then((res) => {
        this.getlist()
      })
    },
    getlist(){
      if(this.queryParams.params.createTime[0]){
        this.queryParams.params.beginCreateTime=this.queryParams.params.createTime[0];
        this.queryParams.params.endCreateTime=this.queryParams.params.createTime[1];
      }
      this.$http2({
        url: `/klgeek/order/mylist?pageNum=${this.queryParams.pageNum}&pageSize=${this.queryParams.pageSize}`,
        method: 'post',
        data:this.queryParams
      }).then((res) => {
        this.tableData=res.rows
        this.total=res.total
      })
    },
    handleQuery(){
      this.getlist();
    },
    currentChange(num){
      if(num){
        this.queryParams.pageNum=num
      }
      this.getlist();
    },
    resetQuery(){
      this.queryParams.params.createTime = [];
      this.queryParams.params.beginCreateTime = null;
      this.$refs.queryFormRef.resetFields();
      this.getlist();
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    loadUserInfo(userId,row) {
      if(!userId) return
      this.$http({
        url: `/user/find/${userId}`,
        method: 'get'
      }).then((user) => {
        this.userInfo = user;
        row.user=user;
      })
    },
    async expandChange(row){
      if(row.user){
        return
      }
      this.loadUserInfo(row.createBy,row);
    }
  },
  mounted(){
    this.getlist();
  },
  data() {
    return {
      showUser:false,
      pos: {
        x: '40%',
        y: '40%',
      },
      userInfo: '',
      total:0,
      way_code:[],
      state:[],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        channelOrderNo: '',
        mchOrderNo: '',
        state: '',
        title: '',
        wayCode: '',
        params: {
          createTime: [],
          beginCreateTime:null,
          endCreateTime:''
        }
      },
      multipleSelection:[],
      tableData: []
    }
  }
}
</script>

<style scoped lang="scss">
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>